import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M3 7C3 5.89543 3.89543 5 5 5H19C20.1046 5 21 5.89543 21 7V8.27273H3V7ZM3 9.5H21V16.0909C21 17.1955 20.1046 18.0909 19 18.0909H5C3.89543 18.0909 3 17.1955 3 16.0909V9.5ZM6.45455 12.3636C5.90226 12.3636 5.45455 12.8114 5.45455 13.3636V13.8182C5.45455 14.3705 5.90226 14.8182 6.45455 14.8182H7.72727C8.27956 14.8182 8.72727 14.3705 8.72727 13.8182V13.3636C8.72727 12.8114 8.27956 12.3636 7.72727 12.3636H6.45455Z"
    fillRule="evenodd"
  />,
  'FilledCreditCardIcon',
)
